// Configurable constants
export const GRID_SIZE = 1000;
export const GRID_DIVISIONS = 100;
export const FOG_COLOR = 0x000000; // Dark fog to match background

// Separate fog controls for left, right, and back
export const BACK_FOG_DENSITY = 0.006; // Fog for the back
